import { flagUrl, langFlagUrl } from "@/lib/flags";
import { cn } from "@/lib/utils";

/**
 * A small country/language flag (flagcdn.com SVG). Pass `lang` for a locale code
 * (mapped to its country) or `country` for an ISO country code. Renders nothing
 * when the code can't be resolved.
 */
export const Flag = ({
  lang,
  country,
  className,
}: {
  lang?: string;
  country?: string;
  className?: string;
}) => {
  const src = lang ? langFlagUrl(lang) : flagUrl(country);
  if (!src) return null;
  return (
    <img
      src={src}
      alt=""
      aria-hidden
      loading="lazy"
      className={cn("inline-block h-3 w-[18px] shrink-0 rounded-[2px] object-cover align-[-1px]", className)}
    />
  );
};

export default Flag;
